import { useMutation } from '@apollo/client'
import { MaterializedProcessesDataTableDocument } from 'generated/resources/datatable.graphql'
import { DestroyMaterializedProcessDocument } from 'generated/resources/graphql'

export const useDestroyMaterializedProcess = () => {
  const [executeMutation] = useMutation(DestroyMaterializedProcessDocument)

  const destroyMaterializedProcess = async (id: number) => {
    const { data, errors } = await executeMutation({
      variables: {
        id,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: MaterializedProcessesDataTableDocument,
          variables: {
            ids: [id],
          },
        },
      ],
    })

    if (
      errors?.length ||
      data?.processesMutations?.destroyProcessesMaterializedProcess?.errors.length
    ) {
      throw (
        'Could not destroy materialized process: ' +
        JSON.stringify([
          ...(errors || []),
          ...(data?.processesMutations?.destroyProcessesMaterializedProcess?.errors || []),
        ])
      )
    }
  }

  return {
    destroyMaterializedProcess,
  }
}
